import { createApiRef } from '@backstage/core-plugin-api';
import { AiAssistantClient } from './AiAssistantClient';

/**
 * API reference for the AI Assistant client
 */
export const aiAssistantApiRef = createApiRef<AiAssistantClient>({
  id: 'plugin.ai-assistant.service',
});

export { AiAssistantClient };
